import { render, staticRenderFns } from "./Hero.html?vue&type=template&id=c35ddb6e&scoped=true&"
import script from "./Hero.vue?vue&type=script&lang=js&"
export * from "./Hero.vue?vue&type=script&lang=js&"
import style0 from "./Hero.scss?vue&type=style&index=0&id=c35ddb6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35ddb6e",
  null
  
)

export default component.exports